/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_TitleInputs */

const en_dr_room_title = /** @type {(inputs: Dr_Room_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agree. Plan. Prove. Ship.`)
};

const id_dr_room_title = /** @type {(inputs: Dr_Room_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepakati. Rencanakan. Buktikan. Rilis.`)
};

/**
* | output |
* | --- |
* | "Agree. Plan. Prove. Ship." |
*
* @param {Dr_Room_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_title = /** @type {((inputs?: Dr_Room_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_title(inputs)
	return en_dr_room_title(inputs)
});